class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('keypress', this.onKeyPress.bind(this));
    }
  }

  isSkuPattern(value) {
    if (!value) return false;
    const trimmedValue = value.trim();
    
    // Define SKU patterns
    const hasHyphenOrSlash = /[-/]/.test(trimmedValue);
    const isAppleCtoSku = /^Z.{8}$/.test(trimmedValue);
    
    // Check if the value matches any of our SKU patterns
    return hasHyphenOrSlash || isAppleCtoSku;
  }

  handleSkuSearch(input) {
    // Get the trimmed SKU value
    const skuValue = input.value.trim();
    
    // Create the properly formatted SKU search query
    const searchQuery = `variants.sku:${skuValue}`;
    
    // Redirect to the search URL with the encoded query
    window.location.href = `/search?q=${encodeURIComponent(searchQuery)}`;
  }

  onKeyPress(event) {
    // Check if enter key was pressed
    if (event.key === 'Enter' || event.keyCode === 13) {
      const input = event.target;
      if (this.isSkuPattern(input.value)) {
        event.preventDefault();
        this.handleSkuSearch(input);
      }
    }
  }

  onFormSubmit(event) {
    if (this.input && this.isSkuPattern(this.input.value)) {
      event.preventDefault();
      this.handleSkuSearch(this.input);
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
